import { Menu, PanelLeftClose, PanelLeft } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { getEnvironment } from '../../lib/cognito-config';

export function TopBar() {
  const { isCollapsed, toggleCollapsed, toggleMobileOpen } = useSidebar();

  return (
    <header className="sticky top-0 z-40 h-14 flex-shrink-0 flex items-center justify-between px-6 border-b border-slate-800 bg-slate-900/95 backdrop-blur-xl">
      <div className="flex items-center gap-2">
        {/* Mobile menu button */}
        <button
          onClick={toggleMobileOpen}
          className="lg:hidden p-2 -ml-2 rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white transition-colors"
        >
          <Menu className="h-5 w-5" />
        </button>

        {/* Desktop collapse button */}
        <button
          onClick={toggleCollapsed}
          className="hidden lg:flex p-2 -ml-2 rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white transition-colors"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? (
            <PanelLeft className="h-5 w-5" />
          ) : (
            <PanelLeftClose className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Right side */}
      <div className="flex items-center gap-3">
        <EnvironmentBadge />
      </div>
    </header>
  );
}

function EnvironmentBadge() {
  const env = getEnvironment();

  const config = {
    local: { label: 'LOCAL', color: 'bg-green-500/20 text-green-400 border-green-500/30' },
    dev: { label: 'DEV', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' },
    prod: { label: 'PROD', color: 'bg-red-500/20 text-red-400 border-red-500/30' },
  }[env];

  return (
    <span
      className={`text-xs px-2.5 py-1 rounded-full font-medium border ${config.color}`}
    >
      {config.label}
    </span>
  );
}
